import { DIGISAKA_API_ORIGIN } from '../../../config/digisakaApiOrigin';

const pointCache = new Map<string, number | null>();

/** Read one pixel from TiTiler `/point`. Nearby clicks reuse the same cell. */
export async function fetchTitilerPointValue(
  cogUrl: string,
  lon: number,
  lat: number,
  options?: {
    bidx?: number;
    nodata?: string;
    signal?: AbortSignal;
    decimals?: number;
  }
): Promise<number | null> {
  const decimals = options?.decimals ?? 2;
  const factor = 10 ** decimals;
  const cellLon = Math.round(lon * factor) / factor;
  const cellLat = Math.round(lat * factor) / factor;
  const bidx = options?.bidx ?? 1;
  const cacheKey = `${cogUrl}|${bidx}|${options?.nodata ?? ''}|${cellLon}|${cellLat}`;
  const cached = pointCache.get(cacheKey);
  if (cached !== undefined) return cached;

  const params = new URLSearchParams({
    url: cogUrl,
    bidx: String(bidx),
  });
  if (options?.nodata) params.set('nodata', options.nodata);
  const endpoint = `${DIGISAKA_API_ORIGIN}/api/point/${cellLon},${cellLat}?${params.toString()}`;
  const res = await fetch(endpoint, { signal: options?.signal });
  if (!res.ok) throw new Error('Could not read the map value here.');
  const data = (await res.json()) as { values?: Array<number | null> };
  const raw = data.values?.[0];
  const value = typeof raw === 'number' && Number.isFinite(raw) ? raw : null;
  pointCache.set(cacheKey, value);
  return value;
}
